import { STORES } from "../../content";

const storeForDevice = () => {
  const ua = typeof navigator === "undefined" ? "" : navigator.userAgent;
  if (/android/i.test(ua)) return STORES.find((s) => s.id === "google-play");
  if (/iphone|ipad|ipod/i.test(ua)) return STORES.find((s) => s.id === "app-store");
  return null;
};

// Opens the store for the visitor's phone once links are set in content.js; otherwise scrolls to the download buttons.
export const GetAppLink = ({ className, children, testid, fallback = "#download" }) => {
  const href = storeForDevice()?.href;
  const ext = href ? { target: "_blank", rel: "noopener noreferrer" } : {};
  return (
    <a href={href || fallback} {...ext} className={className} data-testid={testid}>
      {children}
    </a>
  );
};
